import React, { memo } from 'react'
import RecordClickActionButton from 'root/src/client/web/base/RecordClickActionButton'
import classNames from 'classnames'
import { APPROVE_PROJECT, REJECT_PROJECT, REJECT_ACTIVE_PROJECT } from 'root/src/shared/descriptions/recordClickActions/recordClickActionIds'

export default memo(({
	classes, projectUrl, canApproveProject, canRejectProject, canRejectActiveProject,
}) => (
	<div>
		<div className={classNames(classes.adminButtonsWrapper)}>
			{canApproveProject
			&& (
				<div className={classes.adminButtonContainer}>
					<RecordClickActionButton
						recordClickActionId={APPROVE_PROJECT}
						recordId={projectUrl}
					/>
				</div>
			)}
			{canRejectProject
			&& (
				<div className={classes.adminButtonContainer}>
					<RecordClickActionButton
						recordClickActionId={REJECT_PROJECT}
						recordId={projectUrl}
					/>
				</div>
			)}
			{canRejectActiveProject && !canApproveProject
			&& (
				<div className={classes.adminButtonContainer}>
					<RecordClickActionButton
						recordClickActionId={REJECT_ACTIVE_PROJECT}
						recordId={projectUrl}
						className={classes.dareWrapperHeight}
					/>
				</div>
			)}
		</div>
	</div>
))
